export const getPhoneNumber = (state) => state?.signUp?.sinUpInfo?.ForgetphoneNumber;
